import * as React from 'react';
import AngleRight from '../components/AngleRight';
import WantToSeeHow from '../components/WantToSeeHow';
import EmailContactSales from '../components/EmailContactSales';
import GirlCardScreenCards from '../images/home/girlCardScreenCards.svg';
import { graphql } from 'gatsby';
import DashboardScreenshot from '../images/home/DashboardScreenshot.png';

import Layout from '../components/Layout';
import Portfolio from '../images/home/portfolio.svg';
import StopwatchCheckmark from '../images/home/stopwatch-checkmark.svg';
import TestimonialWoman from '../images/home/tina.jpg';
import ThumbUpInline from '../images/home/thumbUpInline.svg';
import TreesPhoneGuy from '../images/home/trees-phone-guy.svg';
import styled from 'styled-components';
import { Link } from 'gatsby';

import halfSectionGradient from '../images/home/half-section-gradient.png';
import halfSectionWithPattern from '../images/home/half-section-with-pattern.png';

import fullWidthSplitBg from '../images/home/fullWidthSplitBg.png';
import icbaBancard from '../images/home/icbaBancard.png';

import PhonePlayer from '../components/PhonePlayer';
import PhoneVideoMP4 from '../videos/home.mp4';
import PhoneVideoWEBM from '../videos/home.webm';
// import homeVideoThumbnail from '../images/phone/home.jpg';
import homeVideoThumbnail from '../images/phone/home2.jpg';

import leafImage from '../images/home/phoneLeaf.png';
import Testimonial from '../components/Testimonial';
import BlogFeedItem from '../components/BlogFeedItem';

const Section = styled.section`

	& .rounded-box {
		max-width: 550px;
		margin-left: auto;
		margin-right: auto;
	}

	&.banner {
		background-color: #232338;
		color: white;
		width: 100%;
		max-width: none;
		padding-top: 0;
		padding-bottom: 0;
		margin-bottom: 2em;
		background-size: cover;
		background-repeat: no-repeat;

		& .centeredWrapper {
			padding: 1.8em 0 2em;

			& .centered-text {
				text-align: center;
				padding: 0 ${(props) => props.theme.paddingMobile};

				@media (${(props) => props.theme.mediumUp}) {
					padding: 0 ${(props) => props.theme.paddingMediumUp};
				}

				& h2 {
					color: white;
					background-color: #232338;
					margin-bottom: 0.5em;
				}

				& p {
					color: white;
					background-color: #232338;
					font-size: 21px;
					font-weight: normal;
					padding: 0 10%;
					margin-bottom: 0;

					@media (${(props) => props.theme.largeUp}) {
						font-size: 26px;
						max-width: 34em;
						margin-bottom: 0;
						margin-left: auto;
						margin-right: auto;
					}
				}
			}
		}
	}

	&.centered figure {
		@media (${(props) => props.theme.mediumUp}) {
			&:first-child {
				justify-content: center;
			}

			&:last-child {
				justify-content: center;
			}

			&.left-on-desktop {
				justify-content: center;
			}
		}
	}

	&.streamlined-workflows {

		& article {
			display: flex;
			align-items: center;

			& .rounded-box {
				margin-bottom: 0;
			}
		}

		& figure {
			margin-bottom: 0;
			text-align: center;
			flex-direction: column;
			justify-content: center;
			padding-top: 0;
			padding-botom: 0;

			& img {
				max-width: 80%;

				@media (${(props) => props.theme.mediumUp}) {
					max-width: 90%;
				}

				@media (${(props) => props.theme.largeUp}) {
					max-width: 100%;
				}
			}

			& a.hide-md-up {
				align-self: flex-start;
				margin-top: 1em;
			}

			@media (${(props) => props.theme.mediumUp}) {
				max-width: 419px;
				padding-left: 2em;
				padding-top: 1em;
				padding-botom: 1em;
			}

			@media (${(props) => props.theme.largeUp}) {
				max-width: 587px;
				padding-top: 2em;
				padding-botom: 2em;
			}

			@media all and (-ms-high-contrast: none) {
				max-width: 500px;

				img {
					max-width: 400px;
				}
			}
		}
	}

	& article {
		position: relative;

		& .abs-positioned {
			position: absolute;
			right; 0;
			bottom: -20px;
			text-align: right;
			display: block;
			width: 100%;

			@media (${(props) => props.theme.mediumUp}) {
				padding-right: 33px;
			}
		}
	}

	&.two-rounded-boxes {
		align-items: stretch;

		& .rounded-box {
			margin-bottom: 1em;
		}

		& article:first-child .rounded-box {
			margin-bottom: 2em;

			@media (${(props) => props.theme.mediumUp}) {
				margin-bottom: 1em;
			}
		}

		& aside {
			width: 100%;
			margin-bottom: 1em;

			max-width: 550px;
			margin-left: auto;
			margin-right: auto;

			@media (${(props) => props.theme.mediumUp}) {
				margin-right: 0;
			}

			& a {
				text-align: right;
				display: block;
			}
		}

		& article {
			display: flex;
			align-items: stretch;
		}

		@media (${(props) => props.theme.mediumUp}) {
			& article:nth-child(2) {
				padding-left: 2em;
			}
		}
	}

	&.full-width-split figure {
		background-color: #232338;
		background-image: ${(props) => `url('${halfSectionWithPattern}')`};

		@media (${(props) => props.theme.mediumUp}) {
			background-image: ${(props) => `url('${halfSectionGradient}')`};
		}

		& .decorationBehindPhone {
			background-position: left 70%;
			background-image: ${(props) => `url('${leafImage}')`};
			padding: 0 10%;
			background-size: 56px 92px;

			@media (${(props) => props.theme.smallUp}) {
				padding: 0 15%;
				background-size: 113px 184px;
			}

			@media (${(props) => props.theme.mediumUp}) {
				padding: 0 13%;
				background-size: 90px 147px;
			}

			@media (${(props) => props.theme.largeUp}) {
				padding: 0 15%;
				background-size: 113px 184px;
			}
		}
	}

	@media (${(props) => props.theme.mediumUp}) {
		&.blueLeftWhiteRight {
			background-image: ${(props) => `url('${fullWidthSplitBg}')`};
		}
	}

	&.feed {
		margin-bottom: 2em;

		& h2 {
			font-size: 21px;
			color: ${(props) => props.theme.lightBlue};
			text-transform: uppercase;
			margin-bottom: 1em;
		}

		@media (${(props) => props.theme.mediumUp}) {
			& .articlesWrapper {
				justify-content: space-between;
				display: flex;
			}
		}
	}
`;

const HeaderContent = styled.article`
	// max-width: 600px;
	padding-bottom: 1em;
	padding-top: 0 !important;
	display: flex;
	flex-direction: column;

	@media (${(props) => props.theme.mediumUp}) {
		padding-top: 1em !important;
	}

	@media (${(props) => props.theme.largeUp}) {
		padding-top: 1em !important;
	}

	& p {
		max-width: 490px;
	}

	& a.promo {
		margin-top: 1em;
		line-height: 2em;
		display: block;
		margin-bottom: 1.2em;
		padding-left: 15px;

		@media (${(props) => props.theme.mediumUp}) {
			order: -1;
			padding-left: 0;
		}

		& span.new {
			display: inlne-block;
			background-color: #81E2B6;
			padding: 0.3em 0.7em;
			margin-right: 0.8em;

			&:hover {
				cursor: pointer;
				color: black;
			}
		}

		&:hover span.new {
			color: black;
		}

		& span.noWrap {
		  white-space: no-wrap;
		  display: flex;
		  justify-content: space-between;
		  padding-right: 15px;

		  @media (${(props) => props.theme.mediumUp}) {
			// justify-content: flex-start;
			display: inline-block;
		  }
		}
	}

	& .twoC2As {
		display: flex;
		flex-direction: column;
		line-height: 3em;
		align-items: center;
		justify-content: space-between;
		font-family: ${(props) => props.theme.defaultFont};
		width: 100%;

		& form {
			width: 100%;
		}

		& .primary-button {
		  width: 100%;
		  max-width: 100%;
		}

		& .seeUseCases {
			width: 100%;
			display: flex;
			justify-content: space-between;
			padding-left: 15px;
			padding-right: 15px;

			@media (${(props) => props.theme.mediumUp}) {
				width: 210px;
				align-self: flex-start;
			}

			@media (${(props) => props.theme.largeUp}) {
				width: 300px;
				align-self: center;
			}
		}

		@media (${(props) => props.theme.mediumUp}) {
			max-width: 410px;
		}

		@media (${(props) => props.theme.largeUp}) {
			flex-direction: row;
			line-height: normal;
		}
	}
`;

const HeaderBottomContentFigure = styled.figure`
	background: transparent;
	margin-bottom: -1px;

	& svg.bottomAligned {
		max-width: 80%;

		@media (${(props) => props.theme.mediumUp}) {
			max-width: 100%;
		}

		@media (${(props) => props.theme.largeUp}) {
			max-width: 420px;
			position: absolute;
			right: 7%;
			bottom: -2px;
		}

		@media (${(props) => props.theme.xLargeUp}) {
			max-width: 100%;
		}
	}
`;

const WantToSeeHowStyle = { paddingBottom: '1em' };

const indexHeaderContent =
	<HeaderContent style={{marginTop: `0`}}>
		<h1>The new standard<br />in loan origination</h1>
		<p>MK builds intelligent lending solutions for leading community banks, credit unions, and finance companies.</p>
		<div className='twoC2As'>
			<EmailContactSales /> <a href='/credit-cards/' className='seeUseCases cta animate-right'>See Use Cases<AngleRight smallMarginLeft={true} /></a>
		</div>
		<a href='/business-credit-cards/' className='promo animate-right cta newPromo'><span className='new'>NEW</span> <span className='noWrap'>Introducing  Business Credit Cards<AngleRight /></span></a>
	</HeaderContent>
;

	const treesPhoneGuyFigure =
		<HeaderBottomContentFigure>
			<TreesPhoneGuy alt='Man using mobile phone, credit card on phone screen' className='bottomAligned' />
		</HeaderBottomContentFigure>
	;

const IndexPage = (props: any) => {
	return (
	<Layout
		headerBottomContent={treesPhoneGuyFigure}
		headerContent={indexHeaderContent}
		headerContentMaxWidth={'490px'}
		headerSplashBgAverageColor={'white'}
		pageTitle='Online loan origination system for lenders | powering financial institutions'
		skipMoney2020={false}
		splashHeaderMinHeight={'400px'}
		BodyClass={'index UseCases'}
	>
		<Section className='banner full-width'>
			<div className='centeredWrapper'>
				<div className='centered-text'>
					<h2>The complete platform for digital lending</h2>
					<p>We make lending simple by creating modern lending experiences and easy online credit applications.</p>
				</div>
			</div>
		</Section>
		<div className='centeredWrapper'>
			<Section className='streamlined-workflows row row-flush centered'>
				<article className='content col-12 col-md-6'>
					<div className='text-box'>
						<header>
							<StopwatchCheckmark alt='Stopwatch icon' />
							<h2 className='max-width-90'>Streamlined loan<br />origination workflows</h2>
						</header>
						<p>Our platform is easy to implement and gets your financial products to market fast. Built by lenders, for lenders, MK’s products integrate with credit bureaus and core processors to expedite difficult underwriting processes.<br /><br /><Link to='/products/' className='animate-right hide-sm-down exploreProducts cta'>Explore our products<AngleRight /></Link></p>
					</div>

				</article>
				<figure className='col-12 col-md-6'>
					<img src={DashboardScreenshot} alt='MK Lending Dashboard' title='MK Lending Dashboard' />
					<Link to='/products/' className='animate-right hide-md-up exploreProducts cta'>Explore our products<AngleRight /></Link>
				</figure>
			</Section>
		</div>
		<Section className='full-width-split full-width blueLeftWhiteRight'>
			<div className='centeredWrapper'>
				<div className='responsivePadding row row-flush'>
					<article className='col-12 col-md-6 right-on-desktop'>
						<div className='text-box'>
							<header>
								<ThumbUpInline alt='Thumbs up icon' />
								<h2 className='max-width-90'>Simple, beautiful<br />customer experiences</h2>
							</header>
							<p>Our mobile-first loan origination solutions allow borrowers to shop your loan offers, and conveniently apply. MK’s white label interfaces enhance your branding and marketing strategy. Applying for your financial products has never been this easy.<br /><br /><Link to='/credit-cards/' className='hide-sm-down animate-right exploreUseCases cta'>Explore our use cases<AngleRight /></Link></p>
						</div>
					</article>
					<figure className='col-12 col-md-6 left-on-desktop'>
						<PhonePlayer
							PhoneVideoMP4={PhoneVideoMP4}
							PhoneVideoWEBM={PhoneVideoWEBM}
							// thumbnail={homeVideoThumbnail}
						/>
					</figure>
				</div>
			</div>
		</Section>
		<div className='centeredWrapper'>
			<Section className='lets-grow row row-flush centered'>
				<article className='col-12 col-md-6 lets-grow'>
					<Link to='/credit-cards/' className='hide-md-up animate-right exploreUseCases cta'>Explore our use cases<AngleRight /></Link>
					<div className='text-box'>
						<header>
							<Portfolio alt='Portfolio icon' />
							<h2 className='max-width-90'>Let's grow your loan<br />portfolio together</h2>
						</header>
						<p>Banks, credit unions, and finance companies partner with MK Decision to grow their loan portfolios. As your lending partner, we'll make sure processes that used to take hours can now be completed in seconds.</p>
					</div>
				</article>
				<figure className='col-12 col-md-6'>
					<GirlCardScreenCards
						alt='Woman with large card, website with credit cards'
					/>
				</figure>
			</Section>
			<WantToSeeHow extraStyle={WantToSeeHowStyle} />
		</div>
		<Testimonial
			portrait={TestimonialWoman}
			portraitAlt={'Tina Giorgio'}
			name={'Tina Giorgio'}
			title={'President & CEO,'}
			company={'ICBA Bancard'}
			quote={'Through our collaboration with MK Decision, ICBA Bancard continues to push the innovation envelope with solutions that are focused on delivering the very best products to community banks and their customers.'}
			logo={icbaBancard}
			logoAlt={'ICBA Bancard logo'}
		/>

		<div className='centeredWrapper'>
			<Section className='feed'>
				<h2>MK Happenings</h2>
				<div className='articlesWrapper'>
					<BlogFeedItem
						url={'https://mkdecision.com/blog/2020/02/11/mk-decisions-2020-event-schedule/'}
						backgroundImageURL={'https://mkdecision.com/blog/content/images/2020/02/2020-Conferences.gif'}
						backgroundPosition={'center 60%'}
						postCategory={'Events'}
						postTitle={'MK Decision’s 2020 Event Schedule'}
						oneLiner={'Mark your calendars because MK is hitting the road in 2020.'}
					/>
					<BlogFeedItem
						url={'https://mkdecision.com/blog/2020/01/24/the-history-of-signatures/'}
						backgroundImageURL={'https://mkdecision.com/blog/content/images/2020/01/feather-700.jpg'}
						backgroundPosition={'center 60%'}
						postCategory={'SecureSign'}
						postTitle={'The History of Signatures'}
						oneLiner={'Explore how clay seals developed into what we know today as digital signatures.'}
					/>
				</div>
			</Section>
		</div>
	</Layout>
	);
};

export default IndexPage;

export const blogFeed = graphql`
{
allFeedMkBlog {
	edges {
		node {
		title
		link
		isoDate(formatString: "MMMM Do, YYYY")
        contentSnippet
		}
	}
	}
}
`;
